import { graphql } from '../../gql';

export const projectDetailQuery = graphql(`
    query SingleProject($projectId: ID!, $portfolioId: ID!) {
        project(projectId: $projectId, portfolioId: $portfolioId)
    }
`);

export const projectQuery = graphql(`
    query Project($filters: [FilterCriterion]) {
        projects(filters: $filters) {
            items {
                id
                name
                abbreviation
                status
                onHold
                finished
                tagValues {
                    name
                    id
                    portfolioId
                }
                masterPortfolio {
                    id
                }
                parentProjectId
            }
        }
    }
`);

export const projectPortfolioQuery = graphql(`
    query ProjectPortfolio($filters: [FilterCriterion]) {
        projects(filters: $filters) {
            items {
                masterPortfolio {
                    name
                    id
                }
                # themes {
                #     name
                #     uuid
                # }
                # programs {
                #     name
                #     uuid
                # }
                # departments {
                #     name
                #     uuid
                # }
            }
        }
    }
`);

export const projectTeamQuery = graphql(`
    query ProjectTeam($filters: [FilterCriterion]) {
        projects(filters: $filters) {
            items {
                stakeholders
                projectTeam
                projectManager {
                    id
                    fullName
                    firstName
                    lastName
                }
                programManager {
                    id
                    fullName
                    firstName
                    lastName
                }
            }
        }
    }
`);
export const projectPeriodQuery = graphql(`
    query ProjectPeriod($filters: [FilterCriterion]) {
        projects(filters: $filters) {
            items {
                startDate
                endDate
            }
        }
    }
`);

export const projectDescriptionQuery = graphql(`
    query ProjectDescription($filters: [FilterCriterion]) {
        projects(filters: $filters) {
            items {
                description
                goal
                scope
                result
                risks
            }
        }
    }
`);
